module.exports = __webpack_public_path__ + "static/media/project1_1.142b583d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/project1_1.png
// module id = 357
// module chunks = 0